import { Checkbox } from '@access-erp/ui-components';

import styles from './sales-order-details-card.module.scss';
import { SODetails } from '../../hooks/useGetSODetails';
import { getDisplayPayloadJson } from '@/components/common/EnquiriesScreen/utils/troubleshootingPanelHelpers';

interface SalesOrderDetailsCardProps {
  details: SODetails;
}

function Field({ keyName, value }: { keyName: string; value: string | null }) {
  return (
    <div className={styles.field}>
      <span className={styles['field-key']}>{keyName}:</span>
      <span className={styles['field-value']}>{value ?? '-'}</span>
    </div>
  );
}

export function SalesOrderDetailsCard({ details }: SalesOrderDetailsCardProps) {
  const { __typename, payload, consolidationFlag, ...restFields } = details;

  return (
    <div className={styles['so-details']}>
      {Object.entries(restFields).map(([key, value]) => (
        <Field keyName={key} value={value} key={key} />
      ))}
      <div>
        <div className={styles.field}>
          <span>consolidationFlag:</span>
          <div>
            <Checkbox checked={consolidationFlag} disabled={true}></Checkbox>
          </div>
        </div>
        <div>
          <span>payload:</span>
          <pre className={styles.pre}>{getDisplayPayloadJson(payload)}</pre>
        </div>
      </div>
    </div>
  );
}
